import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import { Box } from 'foundations-components/transitional/components/Box';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/transitional/components/View';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import PublicLanguageDropdown from '../../publicLanguage/components/PublicLanguageDropdown';
import PublicSearch from '../../publicSearch/components/PublicSearch';
import PublicPageAuthButtons from './PublicPageAuthButtons';
import PublicPageThemeToggle from './PublicPageThemeToggle';
// @ts-expect-error Could not find a declaration file for module
import orangeAcademyLogo from 'bender-url!../../../../images/HubSpotAcademyOrange.svg';
import PublicPageNavDropdown from './PublicPageNavDropdown';
import PublicPageMobileNavMenu from './PublicPageMobileNavMenu';
import usageTracker from '../../../utils/usageTracker';
import PublicPageNavLink from './PublicPageNavLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PublicPageNavigation = ({
  availableLanguages,
  languageLinkedContent,
  contentType,
  pagePath
}) => {
  const handleTrackNavItemClick = e => {
    var _e$currentTarget;
    usageTracker.track('navInteraction', {
      action: 'nav-item-click',
      // @ts-expect-error href is not a property of HTMLElement
      href: ((_e$currentTarget = e.currentTarget) === null || _e$currentTarget === void 0 ? void 0 : _e$currentTarget.href) || ''
    });
  };
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isMobile &&
    /*#__PURE__*/
    // PrimaryNav
    _jsx(View, {
      as: "nav",
      children: /*#__PURE__*/_jsx(TFlex, {
        alignItems: "center",
        backgroundColor: "fill-field-default",
        borderBlockEndColor: "border-core-subtle",
        borderBlockEndStyle: "solid",
        borderBlockEndWidth: "100",
        inlineSize: "100%",
        insetBlockStart: "0px",
        justifyContent: "center",
        minBlockSize: theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT,
        position: "fixed",
        zIndex: 100,
        children: /*#__PURE__*/_jsx(TFlex, {
          inlineSize: "100%",
          justifyContent: isMobile ? 'space-between' : 'start',
          maxInlineSize: theme.sizes.PUBLIC_PAGE_WIDTH,
          paddingBlock: "0",
          paddingInline: "300",
          position: "relative",
          children: /*#__PURE__*/_jsxs(TFlex, {
            align: "center",
            justify: "between",
            children: [/*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsxs(TFlex, {
                align: "center",
                children: [/*#__PURE__*/_jsx(Box, {
                  marginInlineEnd: "200",
                  children: /*#__PURE__*/_jsx(PublicLanguageDropdown, {
                    contentType: contentType,
                    languageLinkedContent: languageLinkedContent,
                    options: availableLanguages,
                    pagePath: pagePath
                  })
                }), /*#__PURE__*/_jsx(Box, {
                  children: /*#__PURE__*/_jsx(PublicPageThemeToggle, {})
                })]
              })
            }), /*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsxs(TFlex, {
                align: "center",
                children: [/*#__PURE__*/_jsx(Box, {
                  marginInlineEnd: "300",
                  maxInlineSize: "365px",
                  children: /*#__PURE__*/_jsx(PublicSearch, {})
                }), /*#__PURE__*/_jsx(Box, {
                  children: /*#__PURE__*/_jsx(PublicPageAuthButtons, {})
                })]
              })
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      as: "nav",
      children: /*#__PURE__*/_jsx(TFlex, {
        alignItems: "center",
        backgroundColor: "do-not-use-olaf",
        inlineSize: "100%",
        insetBlockStart: isMobile ? '0px' : theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT,
        justifyContent: "center",
        position: "fixed",
        zIndex: 99,
        children: /*#__PURE__*/_jsxs(TFlex, {
          align: "center",
          blockSize: isMobile ? theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT : theme.sizes.PUBLIC_NAV_FULL_HEIGHT,
          inlineSize: "100%",
          justifyContent: isMobile ? 'space-between' : 'start',
          maxInlineSize: theme.sizes.PUBLIC_PAGE_WIDTH,
          paddingBlock: "0",
          paddingInline: "300",
          position: "relative",
          children: [/*#__PURE__*/_jsx(RouterLink, {
            "aria-label": I18n.text('academyPublic.publicNav.hubspotAcademyLogo'),
            marginInlineEnd: "800",
            onClick: handleTrackNavItemClick,
            to: "/",
            children: /*#__PURE__*/_jsx(Image, {
              height: 28,
              src: orangeAcademyLogo,
              width: 200
            })
          }), !isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(PublicPageNavDropdown, {}), /*#__PURE__*/_jsx(PublicPageNavLink, {
              href: getProxyUrl('what-is-hubspot-academy'),
              onClick: handleTrackNavItemClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.publicNav.about"
              })
            })]
          }) : /*#__PURE__*/_jsx(PublicPageMobileNavMenu, {
            availableLanguages: availableLanguages,
            contentType: contentType,
            languageLinkedContent: languageLinkedContent,
            pagePath: pagePath
          })]
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      minBlockSize: isMobile ? theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT : `calc(${theme.sizes.PUBLIC_NAV_FULL_HEIGHT} + ${theme.sizes.PUBLIC_NAV_REDUCED_HEIGHT})`
    })]
  });
};
export default PublicPageNavigation;